export default {"src":"/_next/static/media/Inventories.6d9bccdf.svg","height":25,"width":25};